import { Injectable } from '@angular/core';
import { InternalSettings } from 'src/app/common/services/internal-settings/internal-settings.interface';

@Injectable({
    providedIn: 'root'
})
export class StringUtilityService {

    public static clone<T>(element: T): T {
        return JSON.parse(JSON.stringify(element));
    }

    public static getCustomerFullName(internalSetting: InternalSettings): string {
        if (!internalSetting) return "";
        let profile = internalSetting.profile;
        return `${profile.firstName} ${profile.lastName}`;
    }

    public static nullIfEmpty(entry: string) {
        return entry === '' ? null : entry;
    }

    public static emptyIfNull(entry: string) {
        return entry || '';
    }

    public static join(args: string[], separator: string = ' '): string {
        let params : string[] = [];
        for (const element of args) {
            if (element !== null && element !== undefined && element !== '') {
                params.push(element);
            }
        }
        return params.join(separator).trim();
    }

    public static normalizeLineBreak(str: string): string {
        if (str) return str.replace(/\r\n/g, "\n").replace(/\r/g, "\n").replace(/\\n/g, '\n');
        return str;
    }

    /** 
     * Convert Blob data into Base64 and remove the content type
     */
    public static blobToBase64(blob: Blob, isRaw: boolean = false): Promise<string> {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                let result = (isRaw) ? reader.result as string : (reader.result as string).split(',')[1];
                resolve(result);
            };
        });
    };

    /** Decode a Base64 string to UTF-8 text. */
    public static base64ToUtf8(base64: string): string {
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return new TextDecoder().decode(bytes);
    }

    public static isValidJSON(str: string): boolean {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * Encoding the URL with preserve slash
     */
    public static encodeURIComponent(str: string): string {
        return encodeURIComponent(str).replace(/%2F/g, '/');
    }

    public static sanitizeFilename(str: string): string {
      return str.replace(/[\/\\?%*:|"<>]/g, '_');
    }

    public static truncateText(text: string, maxLength: number = 25): string {
      if (!text) return '';
      return text.length > maxLength
        ? text.slice(0, maxLength) + '...'
        : text;
    }

    public static isEmpty(value: any): boolean {
      if (value === null || value === undefined) {
        return true;
      }
      if (typeof value === 'string' || Array.isArray(value)) {
        return value.length === 0;
      }
      if (value instanceof Map || value instanceof Set) {
        return value.size === 0;
      }
      if (typeof value === 'object') {
        return Object.keys(value).length === 0;
      }
      return false;
    }
}

export enum MEDelimiter {
  Comma = ',',
  Semicolon = ';',
  Colon = ':',
  Pipe = '|',
  Dot = '.',
  Dash = '-',
  Space = ' ',
  ForwardSlash = '/',
}